(() => {
  const CART_UPDATE_URL = "/cart/update.js";

  async function setCartCity(city) {
    const attributes = { selected_city: city || "" };

    const res = await fetch(CART_UPDATE_URL, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "Accept": "application/json",
      },
      credentials: "same-origin",
      body: JSON.stringify({ attributes }),
    });

    if (!res.ok) {
      const text = await res.text().catch(() => "");
      throw new Error(`Cart update failed (${res.status}): ${text}`);
    }

    return res.json();
  }

  function closeCityModal() {
    const modal = document.getElementById("CitySelectorModal");
    if (!modal) return;

    // 1) Если это dawn-style modal-dialog с методом hide()
    if (typeof modal.hide === "function") {
      modal.hide();
      return;
    }

    // 2) Если есть кнопка закрытия (внутри)
    const closeBtn = modal.querySelector(".quick-add-modal__toggle");
    if (closeBtn) closeBtn.click();
  }

  function closeDrawerIfOpen() {
    const details = document.getElementById("Details-menu-drawer-container");
    if (details && details.hasAttribute("open")) {
      details.removeAttribute("open");
    }
  }

  async function handleSelect(city) {
    try {
      await setCartCity(city);

      // обновим текст в модалке мгновенно
      const current = document.querySelector("[data-city-current]");
      if (current) current.textContent = city || "all";

      closeCityModal();
      closeDrawerIfOpen();

      // важно: чтобы Liquid заново отрендерил товары по cart.attributes — перезагрузка
      window.location.reload();
    } catch (e) {
      console.error(e);
      alert("Could not save store selection. Please try again.");
    }
  }

  function onClick(e) {
    const btnSelect = e.target.closest("[data-city-select]");
    if (btnSelect) {
      e.preventDefault();
      handleSelect(btnSelect.getAttribute("data-city-select") || "");
      return;
    }

    const btnClear = e.target.closest("[data-city-clear]");
    if (btnClear) {
      e.preventDefault();
      handleSelect(""); // очистка
      return;
    }
  }

  document.addEventListener("click", onClick, { passive: false });
})();

document.addEventListener("DOMContentLoaded", () => {
  const cards = document.querySelectorAll(".product-card-wrapper[data-product-title]");
  cards.forEach((el) => {
    console.log("PRODUCT:", el.dataset.productTitle);
  });
});
